<template>
  <input @input="input" :value="value">
</template>

<script>
import { debounce } from "debounce";

export default {
  name: "input-debounce",
  props: {
    value: {
      default: ""
    },
  },
  created() {
    this.input = debounce(this.input, 600);
  },
  methods: {
    input(event) {
      this.$emit("input", event.target.value);

      this.$nextTick(() => this.$emit("debouncedInput", event));
    },
  },
};
</script>